import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import axios from "axios"
import VueI18n from 'vue-i18n'

import { translations } from './assets/translations'

//Commented out code from package.json:
//"vue-recaptcha": "^1.2.0",
//"vue-recaptcha-v3": "^1.7.0",

Vue.prototype.$http = axios

Vue.config.productionTip = false;

Vue.use(VueI18n);

Vue.component('loading', {})

var locale = 'nl';
var fallbackLocale = 'en';

const messages = translations;
const i18n = new VueI18n({
  locale: locale,
    fallbackLocale: fallbackLocale,
  messages,
}) 

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");